import { render, staticRenderFns } from "./ModalRemoveGroup.vue?vue&type=template&id=3e9b5d6e&scoped=true"
import script from "./ModalRemoveGroup.vue?vue&type=script&lang=js"
export * from "./ModalRemoveGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9b5d6e",
  null
  
)

export default component.exports